// Home.js
import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import OurTeam from "../components/Team";

const TeamsPage = () => {
  return (
    <>
      <Navbar />
      <OurTeam />
      <Footer />
    </>
  );
};

export default TeamsPage;
